import { Paragraph } from '../../../typography';
import { ToastProps } from '../toast.types';

export function ToastBody({
  body
}: {
  body: ToastProps['body'];
}): JSX.Element | null {
  if (!body) {
    return null;
  }
  return (
    <Paragraph size="sm" color="palette_gray.80">
      {body}
    </Paragraph>
  );
}
